export default __webpack_public_path__ + "static/media/Icon - Close.6437be5d.svg";